import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>Copyright 2022</p>
    </footer>
  );
};

export default Footer;
